import { PRODUCT } from "@/constants";

const defaultValues = {
  avanti: {
    leftSideClassName: "avn-left",
  },
  staysure: {
    leftSideClassName: "sts-left",
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const singleTripeBottomToggleClassNames = defaultValues[brand];

export default singleTripeBottomToggleClassNames;
